import { MoreVert } from '@mui/icons-material';
import { Avatar, List, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { OutlinedPushPin } from 'icons';

const OverflowText = {
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden' as const,
  textOverflow: 'ellipsis' as const,
};

const StyledAvatar = styled(Avatar)<{ open?: boolean }>(({ theme, open }) => ({
  backgroundColor: 'transparent',
  border: '2px solid white',
  fontWeight: 700,
  fontSize: '1rem',
  marginLeft: !open ? `-${theme.spacing(1)}` : undefined, // Centers the avatar if drawer is closed
}));

const StyledSecondaryLink = styled(Link)(() => ({
  color: 'white',
}));

const StyledBottomMenuSubMenuIcon = styled(MoreVert)(() => ({
  color: 'white',
}));

const StyledMenuItemsLabel = styled(MenuItem)(() => ({
  fontStyle: 'normal',
  fontWeight: 'bold',
  fontSize: '0.75rem',
  lineHeight: '16px',
  textTransform: 'uppercase',
}));

const StyledMenuItem = styled(MenuItem)(() => ({
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '1rem',
  lineHeight: '30px',
}));

const StyledMenuItemIcon = styled('div')(() => ({
  paddingRight: '.5em',
}));

const StyledList = styled(List)(() => ({
  marginBottom: '4rem',
}));

const StyleOutlinedPushPin = styled(OutlinedPushPin)(() => ({
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
  '&:hover': {
    opacity: 1,
  },
}));

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  display: 'flex',
  border: 'none',
  borderRadius: 0,  
  boxShadow: 'none',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    cursor: 'pointer',
  },
  '& .MuiListItem-root': {
    border: 'none',
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
  },
}));

export {
  OverflowText,
  StyledAvatar,
  StyledSecondaryLink,
  StyledBottomMenuSubMenuIcon,
  StyledMenuItemsLabel,
  StyledMenuItem,
  StyledMenuItemIcon,
  StyledList,
  StyleOutlinedPushPin,
  StyledLink,
};
